import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles, ArrowLeft } from "lucide-react";
import NavBar from "@/library/components/NavBar";
import Footer from "@/library/components/Footer";
import Breadcrumbs from "@/library/components/Breadcrumbs";
import { api } from "@/library/lib/api";

const Indicators = () => {
  const { domainId } = useParams();
  const [domain, setDomain] = useState(null);
  const [level, setLevel] = useState(null);
  const [inds, setInds] = useState([]);

  useEffect(() => {
    api.get("/domains").then((r) => {
      const d = r.data.find((x) => x.id === domainId);
      setDomain(d);
      if (d) api.get("/levels").then((rl) => setLevel(rl.data.find((l) => l.id === d.level_id)));
    });
    api.get(`/indicators?domain_id=${domainId}`).then((r) => setInds(r.data));
  }, [domainId]);

  return (
    <div data-testid="indicators-page" className="min-h-screen flex flex-col">
      <NavBar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex-1 w-full">
        <Breadcrumbs items={[
          { label: "الرئيسية", to: "/" },
          { label: "المراحل", to: "/library/levels" },
          { label: level?.name || "...", to: level ? `/library/levels/${level.id}` : null },
          { label: domain?.name || "..." }
        ]} />
        <div className="mb-10">
          <div className="text-gold-dark font-bold text-xs tracking-widest uppercase mb-2">{domain?.name}</div>
          <h1 className="font-heading text-3xl md:text-4xl font-extrabold text-brand-dark">المؤشرات</h1>
          <div className="gold-line mt-3"></div>
        </div>
        <div className="grid md:grid-cols-2 gap-4">
          {inds.map((ind, i) => (
            <motion.div key={ind.id} initial={{ opacity: 0, x: 12 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.05 }}>
              <Link to={`/library/indicators/${ind.id}`} data-testid={`indicator-card-${ind.id}`} className="premium-card p-5 block group">
                <div className="flex items-center gap-4">
                  <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-gold/15 to-gold/5 text-gold-dark flex items-center justify-center font-heading font-extrabold text-lg tabular-nums shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-heading font-bold text-brand-dark group-hover:text-brand transition-colors truncate">{ind.name}</h3>
                    {ind.description && <p className="text-xs text-slate-500 mt-1 line-clamp-1">{ind.description}</p>}
                  </div>
                  <ArrowLeft className="w-5 h-5 text-slate-300 group-hover:text-gold-dark group-hover:-translate-x-1 transition-all" />
                </div>
              </Link>
            </motion.div>
          ))}
          {inds.length === 0 && <div className="col-span-2 text-center py-16 text-slate-500">لا توجد مؤشرات</div>}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Indicators;
